
export default function (Component) {
  Component.options.__source = "src/components/d2-link-btn/index.vue"
}
